import { TopBookingModel } from 'api-hooks/guest';
import Separator from 'components/common/separator';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import Text from 'components/elements/text';
import { CardContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  data: TopBookingModel[];
  isLoading: boolean;
}

export default function BookingPreferenceTable(props: Props) {
  const { t } = useTranslation();
  const { data, isLoading } = props;

  const columns = React.useMemo<IColumn<TopBookingModel>[]>(
    () => [
      {
        header: t('common:number'),
        accessorKey: 'name',
        minSize: 100,
        maxSize: 100,
        cell: ({ row }) => <>{row.index + 1}</>,
      },
      {
        header: t(`common:preferences`),
        accessorKey: 'name',
        minSize: 100,
      },
      {
        header: t('common:sub_type'),
        accessorKey: 'subType',
        minSize: 100,
      },
      {
        header: t('common:frequency'),
        accessorKey: 'count',
        minSize: 100,
      },
    ],
    [t],
  );

  return (
    <CardContainer>
      <Text variant="HeadingXSmall">{t('guest:booking_preferences')}</Text>
      <Separator gap={16} />
      <TableComponent
        columns={columns}
        isLoading={isLoading}
        data={data || []}
      />
    </CardContainer>
  );
}
